<template>

   <div class="form-floating">
                        
      <select class="form-select" id="lostLeadReason" v-model.trim="lead.lostLeadReason" @blur="v$.lead.lostLeadReason.$touch"
         @change="v$.lead.lostLeadReason.$touch" :disabled="isLostLead">
         <option selected disabled value>Please choose...</option>
         <option v-for="lostLeadReason in lostLeadReasonList" :value="lostLeadReason.id" :key="lostLeadReason.id">{{lostLeadReason.display_name}}</option>
         <option value="otherReason">Other</option>
      </select>
      <label for="lostLeadReason" class="text-muted">Reason</label>
      <span class="form-text text-danger" v-if="v$.lead.lostLeadReason.$dirty && lead.lostLeadReason==''">
         Reason is required.
      </span>

   </div>

   <div v-if="isOtherLostLeadReason" class="form-floating mt-2">
      <textarea class="form-control" id="otherLostLeadReason" v-model.trim="otherLostLeadReason" @blur="v$.otherLostLeadReason.$touch" 
         placeholder="Please specify reason..." style="height: 70px" :disabled="isLostLead"></textarea>
      <label for="otherLostLeadReason" class="text-muted">Please specify reason...</label>
      <span class="form-text text-danger" v-if="v$.otherLostLeadReason.$error">
         Reason is required.
      </span>
   </div>

   <div v-if="isLostLead" class="text-muted" style="font-style: italic;font-size: 10px;">
      <span>To update reason, go to activity tab.</span>
   </div>

</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { requiredIf } from '@vuelidate/validators'

export default( {

   setup () {
      return { v$: useVuelidate() }
   },

   props: {
      isLeadStatusLost: {
         type: Boolean,
      },

      reason: {
         type: String,
         required: false,
         default: '',
      },
      
   },

	data() {
		return {
         lead: {
            lostLeadReason: '',
         },
         lostLeadReasonList: [],
         isOtherLostLeadReason: false,
         otherLostLeadReason: '',
         isLostLead: false, //indicator whether lead is already a lost lead
		}
	},

   validations() {
      return {
         lead: {
            lostLeadReason: { requiredIf: requiredIf(this.isLeadStatusLost)},
         },
         otherLostLeadReason: { requiredIf: requiredIf(this.isOtherLostLeadReason )}
      }
   },

   created() {
      this.init()
   },

   computed: {

      reasonLost() {
         return this.reason
      },

      lostLeadReason() {
         return this.lead.lostLeadReason
      },

      lossReasonList() {
         return this.lostLeadReasonList
      },

   },

   watch: {

      reasonLost(){
         if (this.reason != ""){
            this.getLostLeadReason()
         }
         
      },

      lostLeadReason() {
         if (this.lead.lostLeadReason == "otherReason") {
            this.isOtherLostLeadReason = true
         } else {
            this.isOtherLostLeadReason = false

            //if lead is already a lost lead, do not reset input
            if (!this.isLostLead) {
               this.v$.otherLostLeadReason.$reset()
               this.otherLostLeadReason = ""
            }
            
         }

      },

      lossReasonList() {
         if (this.lostLeadReasonList.length > 0 && this.isLostLead){
            this.getLostLeadReason()
         }
      },
   },

	methods: {
		init() {
         this.getLostLeadReasonList()

         if (this.reason != "") {
            this.isLostLead = true
         }
         
		},

      resetForm(){
         this.v$.$reset()
         this.lead.lostLeadReason = ""
         this.isOtherLostLeadReason = false
         this.otherLostLeadReason = ""
      },

      // retrieve reason to display
      getLostLeadReason(){
         
         // retrieve lost lead reason id using the note details
         let lostLeadReason = this.lostLeadReasonList.filter(e => {
                              return e.display_name.toLowerCase() == this.reason.toLowerCase()}
                              ).map(e => (e.id)).toString()
         
         this.lead.lostLeadReason = lostLeadReason

         //if none matched within the reason list, it will be displayed as 'Others'
         if (lostLeadReason == "") {
            this.isOtherLostLeadReason = true
            this.lead.lostLeadReason = "otherReason"
            this.otherLostLeadReason = this.reason
         }

      },

      // get display name using lost lead reason id
      lostLeadReasonValue(){
         if (this.isOtherLostLeadReason) {
            return this.otherLostLeadReason
         } else {
            return this.lostLeadReasonList.filter(e => {
                  return e.id == this.lead.lostLeadReason}
                  ).map(e => (e.display_name)).toString()
         }
      },

      async getLostLeadReasonList(){
         await this.$axios.get("/categories?name=LostLeadReason")
         .then((response) => {
            this.lostLeadReasonList = response.data.category.subcategories
         })
         .catch((error) => {
            this.$toast.error(error.response.data.message)
         })
      },
      
	},
});

</script>